import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
	DataGridPremium,
	GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
	GridActionsCellItem,
	GridToolbar
} from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import { muiGridLocales } from "../../../helpers/mui/muiLocales";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import useUserData from "../../../hooks/user/useUserData";
import {ROUTE_PAGE_NEW_REGISTRATION_EDIT, ROUTE_PAGE_REGISTRATION_EDIT} from "../../registrations/routes/routes";
import { PROJECTS } from "../locales/namespaces";



const ProjectRegistration = (props) => {
	const {t} = useTranslation(PROJECTS)
	const {language, dateFormat} = useUserData()
	const { projectId } = props
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange
	} = useMuiGridServerSide({
		url: 'fts/project/edit/works/' + projectId,
		initialPageSize: 50,
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	
	const columns = useMemo(() => {
		return [
			{
				headerName: t('Actions'),
				field: 'actions',
				type: 'actions',
				getActions: (params) => {
					if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
						return []
					}
					return [
						<GridActionsCellItem
							component={Link}
							to={getRouteUrl(ROUTE_PAGE_NEW_REGISTRATION_EDIT, { registrationId: params.id })}
							icon={
								<Tooltip title={t('Edit')}>
									<IconButton>
										<EditIcon/>
									</IconButton>
								</Tooltip>
							}
							color={'info'}
							label={t('Edit')}>
						</GridActionsCellItem>
					]
				}
			},
			{
				field: 'Foreman',
				headerName: t('Foreman'),
				minWidth: 300,
				flex: 1,
			},
			// {
			// 	field: 'Description',
			// 	headerName: t('Project'),
			// 	minWidth: 300,
			// 	flex: 1,
			// },
			{
				field: 'WorkDt',
				headerName: t('WorkDt'),
				minWidth: 180, flex: 1,
				type: 'date',
				align: 'center',
				valueFormatter: (value, row, column, apiRef) => {
					return (value ? dayjs(value).format(dateFormat) : null)
				},
				valueGetter: (value, row, column, apiRef) => {
					return value && new Date(value)
				}
			},
			{
				field: 'WorkTm',
				type: 'number',
				headerName: t('Total Work Time'),
				minWidth: 160, flex: 1,
				valueGetter: (value, row, column, apiRef) => value ? Number(value) : 0,
			},
			{
				field: 'ExtraWorkTm',
				type: 'number',
				headerName: t('Total Extra Work Time'),
				minWidth: 160, flex: 1,
				valueGetter: (value, row, column, apiRef) => value ? Number(value) : 0,
			}
		
		]
	}, [t, dateFormat])
	return (
		<DataGridWrapper sx={{ height: 500 }}>
			<DataGridPremium
				columns={columns}
				initialState={{ density: "compact" }}
				rows={data}
				pagination
				paginationModel={{ page, pageSize }}
				paginationMode="server"
				onPaginationModelChange={onPaginationModelChange}
				rowCount={Number(total)}
				pageSizeOptions={[5, 10, 15, 20, 50, 100]}
				sortingMode="server"
				onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
				filterMode="server"
				onFilterModelChange={onFilterModelChange}
				loading={isLoading}
				localeText={muiGridLocales(language)}
				slots={{
					pagination: CustomPagination,
					toolbar: GridToolbar,
				}}
			/>
		</DataGridWrapper>
	);
};

export default ProjectRegistration